function broadcast(componentName, eventName, params) {
  // console.log(componentName, eventName, params, 'broadcast')
  this.$children.forEach(child => {
    var name = child.$options.componentName;

    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params));
    } else {
      broadcast.apply(child, [componentName, eventName].concat([params]));
    }
  });
}
export default {
  methods: {
    // 向多级父组件传值
    // componentName 组件名
    // eventName 事件名
    // params 参数
    dispatch(componentName, eventName, params) {
      // console.log(componentName, eventName, params, '向多级父组件传值')
      var parent = this.$parent || this.$root;
      var name = parent.$options.componentName;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.componentName;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    // 向子组件广播
    // componentName 组件名
    // eventName 事件名
    // params 参数
    broadcast(componentName, eventName, params) {
      broadcast.call(this, componentName, eventName, params);
    }
  }
};
